// extracted by mini-css-extract-plugin
module.exports = {"SideCard":"SideCard_MSswX"};